import api from '../api'

export default {
    namespaced: true,
    actions: {
        getMessage() {
            return api.post('/maintain/message/query', '查询维护消息内容').then(res => res.data)
        },
        updateMessage(store, params) {
            return api.post('/maintain/message/config', '配置维护消息内容', params)
        }
    }
}